"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8866],{

/***/ 54804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);


/**
 * @description 행사관광정보 BFF
 * @param evCd
 * @returns
 */ var useEventTourDetail = function(evCd) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)({
        queryKey: [
            "useEventTourDetailBFF",
            evCd
        ],
        queryFn: function() {
            return _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/bff/eventTourDetail", {
                params: {
                    evCd: evCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        placeholderData: {
            accommodation: {
                show: false,
                data: [],
                title: ""
            },
            tourSpot: {
                show: false,
                data: [],
                title: ""
            },
            entertainment: {
                show: false,
                data: [],
                title: ""
            },
            food: {
                show: false,
                data: [],
                title: ""
            },
            optionalTour: {
                show: false,
                data: [],
                title: ""
            }
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventTourDetail);


/***/ }),

/***/ 82959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, contentsEmergencySSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 긴급안내 상품코드 조회
 *   `/contents/goods-emergency/{goodsCd}`
 * parameter
 * 		goodsCd : 상품코드
 * ```*/ var key = "useContentsEmergency";
var getPath = function(goodsCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/goods-emergency/").concat(goodsCd);
};
/** ```
 * 긴급안내 상품코드 조회 SSR
 *   `/contents/goods-emergency/{goodsCd}`
 * parameter
 * 		goodsCd : 상품코드
 * ```*/ var contentsEmergencySSR = function(goodsCd) {
    return useConfigureAxios(getPath(goodsCd));
};
/** ```
 * 긴급안내 상품코드 조회
 *   `/contents/goods-emergency/{goodsCd}`
 * parameter
 * 		goodsCd : 상품코드
 * ```*/ var useContentsEmergency = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useContentsEmergency);



/***/ }),

/***/ 7682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sP": function() { return /* binding */ eventDetailAsync; }
/* harmony export */ });
/* unused harmony exports eventDetailSSR, getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23234);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);





var key = "useEventDetail";
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd);
};
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventDetailAsync = function(evCd) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventDetailSSR = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 정보 조회
 *   `/pkg/api/event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventDetail = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .EVENT_DETAIL */ .Ny
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventDetail);



/***/ }),

/***/ 48052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 첫번째 전시 코드 조회
 *   `/pkg/event/{evCd}/first-display`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventFirstDisplay";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/first-display");
};
/** ```
 * 행사 첫번째 전시 코드 조회
 *   `/pkg/event/{evCd}/first-display`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventFirstDisplay = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: {
                evCd: "",
                evNm: "",
                dspSid1: "",
                dspSid2: "",
                dspSid3: "",
                dspSid4: ""
            }
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventFirstDisplay);



/***/ }),

/***/ 58553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event-schedule/{evCd}/hotel-resort`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventHotelResort";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-schedule/").concat(evCd, "/hotel-resort");
};
/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event-schedule/{evCd}/hotel-resort`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventHotelResort = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventHotelResort);



/***/ }),

/***/ 64853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/images`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/ var key = "useEventInfoImages";
var getPath = function(infoId, type, evCd) {
    if (!infoId) return null;
    if (type === "hotel" && evCd) return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-info/").concat(infoId, "/").concat(evCd, "/").concat(type || "travel", "/images");
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-info/").concat(infoId, "/").concat(type || "travel", "/images");
};
/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/images`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/ var useEventInfoImages = function(infoId, type, evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(infoId, type, evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(infoId, type, evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventInfoImages);



/***/ }),

/***/ 12621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/videos`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/ var key = "useEventInfoVideos";
var getPath = function(infoId, type, evCd) {
    if (!infoId) return null;
    if (type === "hotel" && evCd) return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-info/").concat(infoId, "/").concat(evCd, "/").concat(type || "travel", "/videos");
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-info/").concat(infoId, "/").concat(type || "travel", "/videos");
};
/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/videos`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/ var useEventInfoVideos = function(infoId, type, evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(infoId, type, evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(infoId, type, evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventInfoVideos);



/***/ }),

/***/ 80313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사의 보험정보 조회
 *   `/pkg/insurance/by-event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventInsurance";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/insurance/by-event/").concat(evCd);
};
/** ```
 * 행사의 보험정보 조회
 *   `/pkg/insurance/by-event/{evCd}`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventInsurance = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventInsurance);



/***/ }),

/***/ 96487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 현지 정보
 *   `/pkg/event/{eventCode}/local`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventLocal";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/local");
};
/** ```
 * 행사 현지 정보
 *   `/pkg/event/{eventCode}/local`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventLocal = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventLocal);



/***/ }),

/***/ 64767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, eventNoticeSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23234);





/** ```
 * 행사 공지사항
 *   `/pkg/event/{eventCode}/notice`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventNotice";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/notice");
};
/** ```
 * 행사 공지사항 SSR
 *   `/pkg/event/{eventCode}/notice`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventNoticeSSR = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 공지사항
 *   `/pkg/event/{eventCode}/notice`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventNotice = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_2__/* .EVENT_NOTICE */ .Jf
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventNotice);



/***/ }),

/***/ 39810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 선택관광/쇼핑
 *   `/pkg/event-schedule/{evCd}/optional-tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventOptionalTourDetail";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-schedule/").concat(evCd, "/optional-tour-detail");
};
/** ```
 * 선택관광/쇼핑
 *   `/pkg/event-schedule/{evCd}/optional-tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventOptionalTourDetail = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60,
        placeholderData: {
            body: {
                shopList: [],
                optionList: [],
                optionalTourInfo: null
            }
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventOptionalTourDetail);



/***/ }),

/***/ 8745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports eventPriceAsync, getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23234);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);






/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event/{evCd}/price`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventPrice";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event/").concat(evCd, "/price");
};
/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event/{evCd}/price`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var eventPriceAsync = function(evCd) {
    return useConfigureAxios(getPath(evCd), {
        method: "GET"
    });
};
/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event/{evCd}/price`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventPrice = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options), {
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .EVENT_PRICE */ .FY
        }
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useEventPrice);



/***/ }),

/***/ 85777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 비행 경유지 조회
 *   `/pkg/event-schedule/{evCd}/flight`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventScheduleFlight";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-schedule/").concat(evCd, "/flight");
};
/** ```
 * 비행 경유지 조회
 *   `/pkg/event-schedule/{evCd}/flight`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventScheduleFlight = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventScheduleFlight);



/***/ }),

/***/ 28963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 일정표 일차 데이터
 *   `/pkg/event-schedule/${evCd}/${goodsCd}`
 * parameter
 *   `evCd` 행사코드
 *   `goodsCd` 행사코드
 * ```*/ var key = "useEventScheduleTrip";
var getPath = function(evCd, goodsCd) {
    if (!evCd || !goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-schedule/").concat(evCd, "/").concat(goodsCd);
};
/** ```
 * 행사 일정표 일차 데이터
 *   `/pkg/event-schedule/${evCd}/${goodsCd}`
 * parameter
 *   `evCd` 행사코드
 *   `goodsCd` 행사코드
 * ```*/ var useEventScheduleTrip = function(evCd, goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd, goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd, goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventScheduleTrip);



/***/ }),

/***/ 93113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 행사 관광 정보
 *   `/pkg/event-schedule/{evCd}/tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var key = "useEventTourDetail";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/event-schedule/").concat(evCd, "/tour-detail");
};
/** ```
 * 행사 관광 정보
 *   `/pkg/event-schedule/{evCd}/tour-detail`
 * parameter
 *   `evCd` 행사코드
 * ```*/ var useEventTourDetail = function(evCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventTourDetail);



/***/ })

}]);